module.exports = __webpack_public_path__ + "img/Item_Setting.70eed558.svg";